import { render, staticRenderFns } from "./addAreaModal.vue?vue&type=template&id=a8cd7a4c"
import script from "./addAreaModal.vue?vue&type=script&lang=js"
export * from "./addAreaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8cd7a4c')) {
      api.createRecord('a8cd7a4c', component.options)
    } else {
      api.reload('a8cd7a4c', component.options)
    }
    module.hot.accept("./addAreaModal.vue?vue&type=template&id=a8cd7a4c", function () {
      api.rerender('a8cd7a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectConfig/components/addAreaModal.vue"
export default component.exports